export default {
  "content": "<path fill=\"#000\" fill-rule=\"evenodd\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-12a3.002 3.002 0 003.003-3c0-1.657-1.344-3-3.003-3a3.002 3.002 0 00-3.004 3c0 1.657 1.345 3 3.004 3zm-5.924 4.806c-.268.587.21 1.194.856 1.194h10.136c.646 0 1.124-.607.856-1.194A6.509 6.509 0 0012 13a6.509 6.509 0 00-5.924 3.806z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};